<template>
  <div class="text-center">
    <v-dialog
      v-model="modalStatus"
      max-width="500"
      scrollable
      persistent
    >
      <v-card>
        <v-card-text class="pa-0">
          <div class="py-4 px-8">
            <!-- Header -->
            <div class="d-flex flex-row align-center justify-space-between">
              <div class="d-flex flex-row align-center">
                <v-icon color="white" small class="info-icon mr-2">mdi-calendar-edit</v-icon>
                <p class="mb-0 font-weight-bold text-primary title"
                :class="$vuetify.breakpoint.mobile ? 'body-2':''">Editar Fecha Crítica</p>
              </div>
              <div class="d-flex flex-row align-center">
                <v-btn class="mx-2" fab dark small color="#F4516C" @click="closeModalSelf()">
                  <v-icon dark>mdi-close</v-icon>
                </v-btn>
              </div>
            </div>

            <!-- Form content -->
            <v-row align="center" class="mt-4">
              <v-col cols="12">
                <p class="mb-2 subtitle-1">Entrega: <span class="font-weight-bold">{{ entregaData?.title }}</span></p>
                <p class="mb-4 subtitle-2">ID: {{ entregaData?.id }}</p>
              </v-col>
            </v-row>

            <!-- Date picker -->
            <v-row align="center">
              <v-col cols="12" md="4">
                <label class="label-left">Fecha Crítica</label>
              </v-col>
              <v-col cols="12" md="8">
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formattedDate"
                      label="Fecha Crítica"
                      readonly
                      outlined
                      dense
                      v-bind="attrs"
                      v-on="on"
                      hide-details
                      :rules="requiredRule"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="criticalDate"
                    @input="dateMenu = false"
                    :min="minDate"
                    color="#2D4B95"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>

            <!-- Form Buttons -->
            <div class="mt-6">
              <hr class="my-4" />
              <div class="d-flex justify-end">
                <v-btn
                  text
                  color="grey darken-1"
                  @click="closeModalSelf"
                  class="mr-2"
                >
                  Cancelar
                </v-btn>
								<!-- @click="confirmSave" -->
                <v-btn
                  color="#2D4B95"
                  dark
                  :loading="loading"
                >
                  Guardar Cambios
                </v-btn>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import { updateEntrega } from "@/helpers/api/entrega";
import {checkPermissions} from "@/helpers/permissions";

export default {
  name: "EditEntregaModal",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    entregaData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      loading: false,
      dateMenu: false,
      criticalDate: null,
      requiredRule: [v => !!v || "Este campo es requerido"],
      minDate: moment().format("YYYY-MM-DD")
    };
  },
  computed: {
    modalStatus: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    formattedDate() {
      return this.criticalDate ? moment(this.criticalDate).format("DD/MM/YYYY") : "";
    }
  },
  watch: {
    entregaData: {
      handler(newVal) {
        if (newVal && newVal.critical_date) {
          this.criticalDate = moment(newVal.critical_date).format("YYYY-MM-DD");
        } else {
          this.criticalDate = null;
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    checkPermissions: checkPermissions,
    closeModalSelf() {
      this.modalStatus = false;
      this.$emit("close");
    },
    async saveChanges() {
      if (!this.criticalDate) {
        this.showErrorMessage("Por favor seleccione una fecha crítica");
        return;
      }
      
      // Check if the selected date is in the past
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const selectedDate = new Date(this.criticalDate);
      selectedDate.setHours(0, 0, 0, 0);
      
      if (selectedDate < today) {
        this.showErrorMessage("La fecha crítica no puede ser en el pasado");
        return;
      }
      
      if (!checkPermissions(['edit_entrega'])) {
        this.showErrorMessage("No tiene permisos para editar la fecha crítica");
        return;
      }

      this.loading = true;
      try {
        const data = {
          id: this.entregaData.id,
          critical_date: this.criticalDate
        };
        
        const response = await updateEntrega(data);
        
        if (response && response.status === 200) {
          this.showSuccessMessage("Fecha crítica actualizada correctamente");
          this.$emit("update-success");
          this.closeModalSelf();
        } else {
          throw new Error("Error al actualizar la fecha crítica");
        }
      } catch (error) {
        console.error("Error updating critical date:", error);
        this.showErrorMessage("Error al actualizar la fecha crítica");
      } finally {
        this.loading = false;
      }
    },
    showErrorMessage(message) {
      this.$store.commit("setSnackbar", {
        show: true,
        text: message,
        color: "error"
      });
    },
    showSuccessMessage(message) {
      this.$store.commit("setSnackbar", {
        show: true,
        text: message,
        color: "success"
      });
    }
  }
};
</script>

<style scoped>
.info-icon {
  background-color: #2D4B95;
  border-radius: 50%;
  padding: 5px;
}

.label-left {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
}
</style>
